module.exports = __webpack_public_path__ + "static/clutchogbrems_small-2cbaf5f9464f548a823dc7bbb5f6f55d.png";